<template>
    <v-card>
        <s-crud
            :config="config"
            title="Eventos"
            :filter="filter"
            search-input
            add
            :edit="selected?.InsID ? true : false"
            :remove="selected?.InsID ? true : false"
            addNoFunction
            @add="addEvent()"
            @edit="editEvent()"
            ref="scrudEventos"
            @rowSelected="rowSelected($event)"
            group-by="InsID"
            sortable
        >
            <template v-slot:filter>
                <v-container>
                    <v-row style="margin-bottom: 5px;">
                        <v-col cols="12" md="4" class="s-col-form">
                            <s-select-definition 
                                label="Tipo Evento"
                                :def="1067" 
                                v-model="filter.TypeInstruction"
                                clearable
                            />
                        </v-col>
                        <v-col v-if="isLevelArea" cols="12" md="3" class="s-col-form">
                            <s-select-area-allow v-model="filter.AreID" />
                        </v-col>
                        <v-col v-else cols="12" md="4" class="s-col-form">
                            <s-select-area label="Area de Tema" v-model="filter.AreID" :text="filter.AreName" clearable/>
                        </v-col>
                        <v-col cols="6" md="2" class="s-col-form">
                            <s-date v-model="filter.InsDate" label="Inico" />
                        </v-col>
                        <v-col cols="6" md="2" class="s-col-form">
                            <s-date v-model="filter.InsDateEnd" label="Fin" />
                        </v-col>
                        <v-col cols="12" md="8" class="s-col-form">
                            <s-toolbar-subject v-model="filter.IsbID" clearable />
                        </v-col>
                        <!-- <v-col cols="4" md="4" class="s-col-form">
                            <s-select-definition :def="1076" v-model="filter.CtrStatus" label="Estado" />
                        </v-col> -->
                    </v-row>
                </v-container>
            </template>
            <template v-slot:InsStatusName="{ row }">
                <v-chip :color="colorStatus(row.InsStatus)" dark x-small>{{ row.InsStatusName }}</v-chip>
            </template>
        </s-crud>

        <v-dialog v-model="dialogAddEdit" persistent max-width="1200px">
            <v-card>
                <s-toolbar restore @removed="restoreEvent(selected)" :label="selected.InsID ? 'Editando Evento' : 'Agregar Evento'" dark :color="selected.InsID ? 'warning' : 'success'" close @close="closeEvent()" :save="!disabledTotal" @save="saveEvent(selected)">
                    <v-tooltip bottom="">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" text :disabled="disabledCamera" small @click="uploadPDF()"><v-icon>mdi-file-upload</v-icon></v-btn>
                        </template>
                        <span>Subir Pdf</span>
                    </v-tooltip>
                    <v-tooltip bottom="">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" text :disabled="disabledCamera" small @click="openPDF()"><v-icon>mdi-file-pdf-box</v-icon></v-btn>
                        </template>
                        <span>Generar PDF</span>
                    </v-tooltip>
                    <v-tooltip bottom="">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" text :disabled="disabledCamera" small @click="openCamera()"><v-icon>mdi-camera</v-icon></v-btn>
                        </template>
                        <span>Evidencia</span>
                    </v-tooltip>
                </s-toolbar>
                <!-- <fieldset :disabled="disabledTotal" style="margin: 0; padding: 0; border: none;"> -->
                    <v-container style="padding: 15px 25px">
                        <v-row style="margin-bottom: 5px;">
                            <v-col cols="12" md="4" class="s-col-form">
                                <s-date v-model="selected.InsDate" :disabled="disabledTotal"/>
                            </v-col>
                            <v-col cols="12" md="4" class="s-col-form">
                                <s-select-definition 
                                    label="Tipo Evento"
                                    :def="1067" 
                                    v-model="selected.TypeInstruction"
                                    :disabled="disabledTotal"
                                />
                            </v-col>
                            <v-col cols="12" md="4" class="s-col-form">
                                <s-select-campaign-se 
                                    label="Campaña"
                                    v-model="selected.CmpID"
                                    disabled
                                />
                            </v-col>
                            <v-col cols="6" md="2" class="s-col-form" v-if="selected.TypeInstruction==2||selected.TypeInstruction==8">
                                <s-select-definition 
                                    label="Modalidad"
                                    :def="1459" 
                                    v-model="selected.TypeModality"
                                    :disabled="disabledTotal"
                                />
                            </v-col>
                            <v-col cols="6" md="2" class="s-col-form" v-if="selected.TypeInstruction==2||selected.TypeInstruction==8">
                                <s-select-definition 
                                    label="Tipo de Costo"
                                    :def="1460" 
                                    v-model="selected.TypeCost"
                                    :disabled="disabledTotal"
                                />
                            </v-col>
                            <!-- <v-col cols="2" class="s-col-form" v-if="selected.TypeInstruction==2||selected.TypeInstruction==8 && selected.TypeCost == 2">
                                <s-text :disabled="disabledTotal" label="Monto de Costo" v-model.number="selected.AmountCost" decimal/>
                            </v-col>  -->
                            <!-- <v-col cols="2" class="s-col-form" v-if="selected.TypeInstruction==2||selected.TypeInstruction==8 && selected.TypeCost == 2">
                                <s-select-definition 
                                    label="Moneda"
                                    :def="1129" 
                                    v-model="selected.TypeCurrency"
                                    :disabled="disabledTotal"
                                />
                            </v-col> -->
                            <!-- <v-col cols="12" md="4" class="s-col-form" v-if="selected.TypeInstruction==2||selected.TypeInstruction==8 && selected.InsTypeCapacitor == 2">
                                <v-label><b>Centro de Costo</b></v-label>
                                <v-autocomplete
                                    v-model="centerCostModel"
                                    :items="itemsCenterCost"
                                    hide-details
                                    dense
                                    multiple
                                    clearable
                                    chips
                                    deletable-chips
                                    solo
                                    class="autocompleteQuery"
                                    :disabled="disabledTotal"
                                ></v-autocomplete>
                            </v-col>  -->
                            <v-col cols="12" md="2" class="s-col-form" v-if="selected.TypeInstruction==2||selected.TypeInstruction==8">
                                <s-select-definition 
                                    label="Tipo Capacitor"
                                    :def="1559" 
                                    v-model="selected.InsTypeCapacitor"
                                    :disabled="disabledTotal"
                                />
                            </v-col>
                            <v-col cols="12" md="2" class="s-col-form" v-if="selected.TypeInstruction==2||selected.TypeInstruction==8">
                                <s-select-definition 
                                    label="Sitio"
                                    :def="1560" 
                                    v-model="selected.InsSite"
                                    :disabled="disabledTotal"
                                    :add="$fun.isAdmin()"
                                />
                            </v-col>
                            <v-col cols="12" md="4" class="s-col-form" v-if="selected.TypeInstruction==2||selected.TypeInstruction==8">
                                <!-- <s-text :label="selected?.InsTypeCapacitor == 1 ? 'Area Ponente': 'Area Solicitante'" v-model="selected.InsAreSpeaker" :disabled="disabledTotal"></s-text> -->
                                <s-select-area
                                    :label="selected?.InsTypeCapacitor == 1 ? 'Area Ponente': 'Area Solicitante'"
                                    :text="selected.AreName"
                                    v-model="selected.InsAreSpeaker"
                                    :disabled="disabledTotal"
                                />
                            </v-col>
                            <v-col cols="12" class="s-col-form">
                                <s-text label="Observaciones" v-model="selected.InsObservation" :disabled="disabledTotal"/>
                            </v-col>
                            <v-col cols="12" md="4" class="s-col-form">
                                <s-select-definition 
                                    label="Estado"
                                    :disabled="!$fun.hasSpecialPermission('IsGestion') || disabledTotal"
                                    :def="1579" 
                                    v-model="selected.InsStatus"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                    <!-- <fieldset :disabled="selected?.InsID ? false : true" style="margin: 0; padding: 0; border: none;"> -->
                        <v-container>
                            <v-row style="margin-bottom: 5px;">
                                <v-col cols="12" md="6">
                                    <s-crud
                                        title="Capacitores"
                                        formPermanent
                                        ref="crudInstruction"
                                        :remove="selectedCapacitor?.IinID ? true : false"
                                        noSearch
                                        colorToolbar="info"
                                        :filter="filterCapacitor"
                                        :config="configCapacitor"
                                        @save="saveCapacitor($event)"
                                        noConfimationSave
                                        noFooter
                                        @rowSelected="rowSelectedCapacitor($event)"
                                        :viewEventFormPermanent="!$fun.hasSpecialPermission('IsGestion')"
                                    >
                                        <template v-slot="props">
                                            <v-container v-if="props && props.item">
                                                <v-row class="mt-n3">
                                                    <v-col cols="12" md="9" class="s-col-form">
                                                        <s-toolbar-subject
                                                            ref="tbIinSubject"
                                                            add
                                                            v-model="props.item.IsbID"
                                                            @returnSubject="iinReturnSubject($event, props.item)"
                                                            clearable
                                                            :disabled="disabledTotal"
                                                        />
                                                    </v-col>
                                                    <v-col cols="4" md="3" class="s-col-form">
                                                        <s-text
                                                            label="Duración (min)"
                                                            number
                                                            :min="min"
                                                            v-model="props.item.IinDurationTime"
                                                            readonly
                                                        ></s-text>
                                                    </v-col>
                                                    <v-col cols="8" md="4" class="s-col-form">
                                                        <s-toolbar-person
                                                            ref="DNI"
                                                            v-model="props.item.IinDocumentNumber"
                                                            @returnPerson="returnInstructor($event, props.item)"
                                                            :autofocus="false"
                                                            type="text"
                                                            :noEdit="(selected?.InsTypeCapacitor == 1)"
                                                            :disabled="disabledTotal"
                                                        />
                                                    </v-col>
                                                    <v-col cols="12" md="8" class="s-col-form">
                                                        <s-text
                                                            label="Capacitador"
                                                            v-model="props.item.IinNamePerson"
                                                            :readonly="hasWorker"
                                                            :disabled="disabledTotal"
                                                        />
                                                    </v-col>
                                                    <v-col cols="12" v-if="selected.InsTypeCapacitor == 2" class="s-col-form">
                                                        <s-text v-model="props.item.NameCompanyCapacitor" label="Empresa" clearable></s-text>
                                                    </v-col>
                                                    <v-col cols="6" class="s-col-form">
                                                        <s-load v-model="fileCapacitor.CvCompanyCapacitor" label="CV" clearable :disabled="!$fun.hasSpecialPermission('IsGestion') || disabledTotal"></s-load>
                                                        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 5px;" v-if="props.item.CvCompanyCapacitor">
                                                            <v-label>Cv_Capacitador_{{ props.item.IinID }}.{{ props.item.CvCompanyCapacitor.split('.').pop() }}</v-label>
                                                            <v-btn x-small color="success" @click="downloadFile(props.item.CvCompanyCapacitor)">
                                                                <v-icon>mdi-download</v-icon>
                                                            </v-btn>
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="6" class="s-col-form">
                                                        <s-load v-model="fileCapacitor.InformeCompanyCapacitor" label="Informe" clearable :disabled="!$fun.hasSpecialPermission('IsGestion') || disabledTotal"></s-load>
                                                        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 5px;" v-if="props.item.InformeCompanyCapacitor">
                                                            <v-label>Informe_Capacitador_{{ props.item.IinID }}.{{ props.item.InformeCompanyCapacitor.split('.').pop() }}</v-label>
                                                            <v-btn x-small color="success" @click="downloadFile(props.item.InformeCompanyCapacitor)">
                                                                <v-icon>mdi-download</v-icon>
                                                            </v-btn>
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <s-textarea label="Observaciones" v-model="props.item.IObservation" :disabled="disabledTotal"></s-textarea>
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <s-text
                                                        type="time"
                                                        label="Hora Inicio"
                                                        v-model="props.item.IInicioTime"
                                                        :disabled="(props.item.IinDurationTime == null || props.item.IinDurationTime === '') || disabledTotal"
                                                        @input="calcularHoraFin(props.item)"
                                                        />
                                                    </v-col>
                                                    <v-col cols="6">
                                                        <s-text 
                                                            type="time"
                                                            label="Hora Fin"
                                                            v-model="props.item.IFinTime"
                                                            :disabled="(props.item.IinDurationTime == null || props.item.IinDurationTime === '') || disabledTotal"
                                                        ></s-text>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </template>
                                    </s-crud>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <s-toolbar label="Asistencia por Capacitador" dark color="#8e8f91" :remove="(selectedAttendanceCapacitor.length > 0? true : false) && $fun.hasSpecialPermission('IsGestion')" @removed="removeAttendanceCapacitor(selectedAttendanceCapacitor)"></s-toolbar>
                                    <v-container>
                                        <v-row style="margin-bottom: 5px;">
                                            <v-col cols="12" class="s-col-form">
                                                <s-text label="Nombre o DNI" v-model="PrsDocumentNumber_AttendanceCapacitor"/>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                    <v-data-table
                                    :headers="configAttendance.headers"
                                    :items="itemsCapacitor"
                                    v-model="selectedAttendanceCapacitor"
                                    @click:row="selectedCheckSlot($event)"
                                    item-key="IasID"
                                    dense
                                    >

                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-container>
                        <v-container>
                            <v-row style="margin-bottom: 5px;">
                                <v-col cols="12">
                                    <v-card>
                                        <s-crud
                                            title="Asist."
                                            ref="crudAttendance"
                                            :rowDefault="false"
                                            noDark
                                            :add="$fun.hasSpecialPermission('IsGestion')"
                                            :edit="$fun.hasSpecialPermission('IsGestion')"
                                            exportExcel
                                            :remove="$fun.hasSpecialPermission('IsGestion')"
                                            noSearch
                                            noBorder
                                            :filter="filterAttendance"
                                            :config="configAttendance"
                                            @save="saveAttendance($event)"
                                            @rowSelected="rowSelectedAttendance($event)"
                                            class="py-0 my-0"
                                            noConfimationSave
                                            :single-row="false"
                                            :itemsPerPage="[-1]"
                                        >
                                            <template v-slot:options v-if="$fun.hasSpecialPermission('IsGestion')">
                                                <v-tooltip bottom="">
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn
                                                            v-on="on"
                                                            text
                                                            black 
                                                            @click="openRegister()"
                                                            small
                                                        >
                                                            <v-icon>mdi-badge-account</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Registro por FotoCheck</span>
                                                </v-tooltip>
                                            </template>
                                            <template v-slot:filter>
                                                <v-container>
                                                    <v-row style="margin-bottom: 5px;">
                                                        <v-col cols="12" md="4" class="s-col-form">
                                                            <s-date
                                                                label="Fecha"  
                                                                v-model="filterAttendance.IasDate"
                                                            />
                                                        </v-col>
                                                        <v-col cols="12" md="8" class="s-col-form">
                                                            <s-text label="Nombre o DNI" v-model="filterAttendance.PrsDocumentNumber"/>
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </template>
                                            <template v-slot="props">
                                                <v-container v-if="props && props.item">
                                                    <v-row class="mt-n3">
                                                        <v-col cols="4" class="s-col-form">
                                                            <s-toolbar-person
                                                                ref="tbIasPerson"
                                                                v-model="props.item.IasDocumentNumber"
                                                                @returnPerson="returnPersonAttendance($event, props.item)"
                                                                :autofocus="false"
                                                                type="text"
                                                            />
                                                        </v-col>
                                                        <v-col cols="8" class="s-col-form">
                                                            <s-text
                                                                label="Asistente"
                                                                v-model="props.item.NtpFullName"
                                                                clearable
                                                            />
                                                        </v-col>                                                    
                                                        <v-col sm="6">
                                                            <s-select-area
                                                                label="Area*"  
                                                                :text="props.item.AreName"
                                                                v-model="props.item.AreID"
                                                            />
                                                        </v-col>
                                                        <v-col sm="3">
                                                            <s-date
                                                                label="Fecha"  
                                                                v-model="filterAttendance.IasDate"
                                                                disabled
                                                            />
                                                        </v-col>
                                                    </v-row>
                                                </v-container>
                                            </template>
                                        </s-crud>
                                        <v-row>
                                            <v-col>
                                                <v-btn @click="saveAttendanceInstructor()" :disabled="(selectedCapacitor?.NtpFullName? false : true) && $fun.hasSpecialPermission('IsGestion')" block color="success"><v-icon>mdi-content-save</v-icon>&nbsp;Guardar asistencia para : {{ selectedCapacitor?.NtpFullName }}</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    <!-- </fieldset> -->
                <!-- </fieldset> -->
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogCamera" transition="dialog-bottom-transition" max-width="900px">
            <v-card>
                <s-toolbar label="Evidencias" close @close="dialogCamera = false" dark color="success" :save="$fun.hasSpecialPermission('IsGestion')" @save="saveEvidence(selected.InsID)"></s-toolbar>
                <v-container>
                <v-row>
                    <v-col cols="12" md="6">
                        <s-load v-if="$fun.hasSpecialPermission('IsGestion')" type="file" camera img label="Evidencia 1 (Solo Imagenes)" v-model="anexosInstruction.itemAnexo1"></s-load>
                        <v-card :loading="loadingItemAnexo1" style="margin-top: 5px;">
                            <img
                                :src="anexosInstruction.itemAnexo1DB"
                                alt=""
                                style="width: 100%; height: 300px; object-fit: contain; border: 1px solid #ccc; margin-top: 5px;"
                            />
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                        <s-load v-if="$fun.hasSpecialPermission('IsGestion')" type="file" camera img label="Evidencia 2 (Solo Imagenes)" v-model="anexosInstruction.itemAnexo2"></s-load>
                        <v-card :loading="loadingItemAnexo2" style="margin-top: 5px;">
                            <img
                                :src="anexosInstruction.itemAnexo2DB"
                                alt=""
                                style="width: 100%; height: 300px; object-fit: contain; border: 1px solid #ccc; margin-top: 5px;"
                            />
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                        <s-load v-if="$fun.hasSpecialPermission('IsGestion')" type="file" camera img label="Flyer del evento (Imagen)" v-model="anexosInstruction.itemAnexo4"></s-load>
                        <v-card :loading="loadingItemAnexo4" style="margin-top: 5px;">
                            <img
                                v-if="anexosInstruction.itemAnexo4DB"
                                :src="anexosInstruction.itemAnexo4DB"
                                alt=""
                                style="width: 100%; height: 300px; object-fit: contain; border: 1px solid #ccc; margin-top: 5px;"
                            />
                        </v-card>
                    </v-col>
                </v-row>
                <!-- <v-row>
                    <v-col cols="6">
                    <img
                        :src="anexosInstruction.itemAnexo1DB"
                        alt=""
                        style="width: 100%; height: 300px; object-fit: contain; border: 1px solid #ccc;"
                    />
                    </v-col>
                    <v-col cols="6">
                    <img
                        :src="anexosInstruction.itemAnexo2DB"
                        alt=""
                        style="width: 100%; height: 300px; object-fit: contain; border: 1px solid #ccc;"
                    />
                    </v-col>
                </v-row> -->
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogRegister" persistent max-width="1000px">
            <v-card>
                <s-toolbar label="Registro por FotoCheck" close @close="dialogRegister = false" dark color="success"></s-toolbar>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <s-toolbar-person label="DNI" v-model="PrsDocumentNumber" ref="document" autofocus @returnPerson="returnPersonAttendanceMasive($event, selectMasive)"></s-toolbar-person>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="4">
                            <img style="width: 100%; height: 300px; object-fit: contain;" v-if="image" :src="image" alt="Imagen de Base64">
                        </v-col>
                        <v-col cols="8">
                            <v-row>
                                <v-col cols="12" align="center" class="s-col-form">
                                    <h1 style="font-size: 35px;">
                                        {{ selectMasive.NtpFullName }}
                                    </h1>
                                </v-col>
                                <v-col cols="12" align="center" class="s-col-form">
                                    <h3 style="font-size: 25px;">
                                        {{ selectMasive.PrsDocumentNumber }}
                                    </h3>
                                </v-col>
                                <v-col cols="12" align="center" class="s-col-form">
                                    <h2 style="font-size: 30px;">
                                        {{ selectMasive.AreName }}
                                    </h2>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-if="dialogPDF" v-model="dialogPDF" persistent>
			<InstructionPDF :InsObject="selected" :IasDate="IasDate" @close="dialogPDF = false"></InstructionPDF>
		</v-dialog>

        <v-dialog v-model="dialogDatePdf" persistent max-width="300px">
            <v-card>
                <s-toolbar label="Seleccione una fecha" dark color="#8e8f91" close @close="dialogDatePdf = false"></s-toolbar>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <s-date v-model="IasDate" label="Fecha" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" align="center">
                            <v-btn block color="success" @click="selectPDF()">Generar PDF</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogUploadPDFEvent" persistent max-width="500px">
            <v-card>
                <s-toolbar label="Subir PDF del Evento" dark color="#8e8f91" close @close="dialogUploadPDFEvent = false"></s-toolbar>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <s-load type="file" pdf label="PDF" v-model="anexosInstruction.itemAnexo3"></s-load>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" align="center">
                            <v-btn block color="success" @click="uploadPDFEvent()">Subir PDF</v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" align="center">
                            <v-btn :disabled="(selected.itemAnexo3 != null && selected.itemAnexo3 != '') ? false : true" block color="info" @click="downloadFile(selected.itemAnexo3)">Descargar PDF</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import sToolbarPerson from "@/components/Utils/Person/sToolbarPerson";
import sToolbarSubject from "@/views/Management/Instruction/SToolbarSubject.vue";
import _sInstruction from "@/services/Management/InstructionService";
import _sInstructionInstructor from "@/services/Management/InstructionInstructorService";
import _sInstructionAttendance from "@/services/Management/InstructionAttendanceService";
import GenUploadFiles from "@/services/General/GenUploadFiles";
import HelperService from "@/services/HelperService";
import InstructionPDF from "./InstructionPDF.vue";

export default {
    components: {
        sToolbarPerson,
        sToolbarSubject,
        InstructionPDF
    },
    data() {
        return {
            PrsDocumentNumber_AttendanceCapacitor: '',
            dialogDatePdf: false,
            IasDate: this.$fun.getDate(),
            dialogPDF: false,
            image: null,
            dialogRegister: false,
            isLevelArea: false,
            filter: {
                AreID: 0,
                IsbID: null,
                InsDate: this.$fun.getDate(),
                InsDateEnd: this.$fun.getDate(),
                // CtrStatus: 1,
                AreName: null
            },
            config: {
                service: _sInstruction,
                model: {
                    TableID: "ID",
                    InsDate: "date",
                },
                headers: [
                    { text: "Evento N° ", value: "InsID" },
                    { text: "Fecha", value: "InsDate" },
                    { text: "Nombre", value: "NtpFullName" },
                    { text: "Area", value: "AreAbbreviation" },
                    { text: "Tema", value: "IsbSubject" },
                    { text: "Tipo", value: "TypeInstructionText" },
                    { text: "Estado", value: "InsStatusName" },
                ]
            },
            configCapacitor: {
                service: _sInstructionInstructor,
                model: {
                    IinID: "ID",
                },
                headers: [
                    { text: "ID", value: "IinID" },
                    { text: "Instructor", value: "IinNamePerson" },
                    { text: "Tema", value: "IsbSubject" },
                    { text: "Tipo", value: "TypeInstructionText" },
                    { text: "Área", value: "AreAbbreviation" },
                    { text: "Duración (Min)", value: "IinDurationTime" },
                    { text: "Hora Inicio", value: "IInicioTime" },
                    { text: "Hora Fin", value: "IFinTime" },
                    { text: "Observaciones", value: "IObservation" }
                ],
            },
            configAttendance: {
                service: _sInstructionAttendance,
                model: {
                    IasID: "ID",
                    IasDate: "date",
                },
                headers: [
                    { text: "Doc", value: "PrsDocumentNumber" },
                    { text: "Asistente", value: "NtpFullName" },
                    { text: "Puesto", value: "PstName" },
                    { text: "Área", value: "AreAbbreviation" },
                    { text: "Fecha", value: "IasDate" }
                ],
            },
            itemsCenterCost: [],
            itemsCapacitor: [],
            selected: {
                InsID: 0,
                TypeInstruction: 1,
                InsTypeCapacitor: 1
            },
            selectedCapacitor: {
                InsID: 0,
                IinID: 0
            },
            selectedAttendance: [],
            dialogAddEdit: false,
            fileCapacitor: {
                CvCompanyCapacitor: null,
                InformeCompanyCapacitor: null
            },
            hasWorker: false,
            min: 0,
            disabledCamera: true,
            dialogCamera: false,
            anexosInstruction: {
                itemAnexo1: null,
                itemAnexo2: null,
                itemAnexo3: null,
                itemAnexo4: null,
                itemAnexo1DB: null,
                itemAnexo2DB: null,
                itemAnexo4DB: null,
            },
            selectedAttendanceCapacitor: [],
            selectMasive: {},
            PrsDocumentNumber: null,
            disabledTotal: false,
            filterAttendance: {
                InsID: this.selected?.InsID,
                IasDate: this.$fun.getDate(),
                PrsDocumentNumber: null
            },
            dialogUploadPDFEvent: false,
            loadingItemAnexo1: false,
            loadingItemAnexo2: false,
            loadingItemAnexo4: false,
            googleAccessToken: null,
        }
    },
    methods: {
        uploadPDF() {
            this.dialogUploadPDFEvent = true;
        },
        openPDF() {
            this.dialogDatePdf = true;
        },
        selectPDF() {
            this.dialogPDF = true;
            this.dialogDatePdf = false;
        },
        async saveEvent(item){
            
            item.UsrCreateID = this.$fun.getUserID();
            item.UsrUpdateID = this.$fun.getUserID();
            item.SecStatus = 1;

            console.log(item);

            await _sInstruction.save(item, this.$fun.getUserID()).then(resp => {
                if(resp.status == 200){
                    console.log(resp);
                    const { data } = resp;
                    this.selected.InsID = data.InsID;
                    if(data.InsStatus == 3){
                        this.disabledTotal = true;
                    }
                    else{
                        this.disabledTotal = false;
                    }
                    this.$fun.alert("Guardado Correctamente", "success");
                    this.filterAttendance.InsID = data.InsID;
                }
            })
        },
        async restoreEvent(item){
            item.UsrCreateID = this.$fun.getUserID();
            item.UsrUpdateID = this.$fun.getUserID();
            item.SecStatus = 1;
            item.InsStatus = 2;

            console.log(item);

            await _sInstruction.save(item, this.$fun.getUserID()).then(resp => {
                if(resp.status == 200){
                    this.$fun.alert("Habilitado Correctamente", "success");
                    this.disabledTotal = false;
                }
            })
        },
        async saveCapacitor(item){
            await this.saveEvent(this.selected);

            item.InsID = this.selected.InsID;
            item.UsrCreateID = this.$fun.getUserID();
            item.UsrUpdateID = this.$fun.getUserID();
            item.SecStatus = 1;

            let IinIDSave = item.IinID || null;
            console.log('IinIDSave', item, IinIDSave);

            if(!IinIDSave){
                console.log("Ingreso a traer ID");
                await _sInstructionInstructor.save(item, this.$fun.getUserID()).then(resp => {
                    if(resp.status == 200){
                        console.log(resp);
                        const { data } = resp;
                        item.IinID = data.IinID;
                        item.InsID = data.InsID;
                        IinIDSave = data.IinID;
                    }
                })
            }

            if(IinIDSave){
                console.log("CvCompanyCapacitor", this.fileCapacitor.CvCompanyCapacitor);
                console.log("InformeCompanyCapacitor", this.fileCapacitor.InformeCompanyCapacitor);

                let cont = 0;
                let fallos = 0;

                if (this.fileCapacitor.CvCompanyCapacitor) {
                    try {
                        const respImg = await GenUploadFiles.upload(this.fileCapacitor.CvCompanyCapacitor, `IinID_${IinIDSave}_CvCompanyCapacitor`, "routeGestionHumana", true);
                        if(respImg.status == 200){
                            cont++;
                            item.CvCompanyCapacitor = respImg.data.fileName;
                        }
                    } catch (error) {
                        fallos ++;
                        this.$fun.alert("Error al subir la foto", "warning");
                        console.error("Error al subir la foto", error);
                    }
                }

                if(this.fileCapacitor.InformeCompanyCapacitor){
                    try {
                        const respImg = await GenUploadFiles.upload(this.fileCapacitor.InformeCompanyCapacitor, `IinID_${IinIDSave}_InformeCompanyCapacitor`, "routeGestionHumana", true);
                        if(respImg.status == 200){
                            cont++;
                            item.InformeCompanyCapacitor = respImg.data.fileName;
                        }
                    } catch (error) {
                        fallos ++;
                        this.$fun.alert("Error al subir la foto", "warning");
                        console.error("Error al subir la foto", error);
                    }
                }

                if(cont > 0 && fallos == 0){
                    this.$fun.alert("Anexos Guardados", "success");
                    this.fileCapacitor.CvCompanyCapacitor = null;
                    this.fileCapacitor.InformeCompanyCapacitor = null;
                }
                else{
                    this.$fun.alert("Error al subir los anexos", "warning");
                }
            }

            item.SecStatus = 1;
            console.log("ItemFinal:",item);

            item.save();
        },
        saveAttendance(item){
            item.InsID = this.selected.InsID;
            item.IasDate = this.filterAttendance.IasDate;
            console.log(item);
            
            item.save();
        },
        rowSelected(item){
            if(item !== null && item.length > 0){
                this.selected = item[0];
            }else{
                this.selected = {};
            }
        },
        rowSelectedCapacitor(item){
            if(item !== null && item.length > 0){
                this.selectedCapacitor = item[0];

                this.paginationListCapacitor(this.selectedCapacitor);
            }else{
                this.selectedCapacitor = {};
            }
        },
        selectedCheckSlot(obj) {
            console.log(obj);
            if(obj !== null){
                this.selectedAttendanceCapacitor = [];
                this.selectedAttendanceCapacitor.push(obj);
            }
        },
        paginationListCapacitor(item){
            this.itemsCapacitor = [];
            console.log('paginationList', item);
            if(!item.IinID) return;
            _sInstructionAttendance.paginationList(item.IinID, this.PrsDocumentNumber_AttendanceCapacitor, this.filterAttendance.IasDate, this.$fun.getUserID())
                .then(resp => {
                    if(resp.status == 200)
                    {
                        this.selectedAttendanceCapacitor = [];
                        this.itemsCapacitor = resp.data;
                    }
                })
        },
        rowSelectedAttendance(items){
            if(items !== null && items.length > 0){
                this.selectedAttendance = items;
            }else{
                this.selectedAttendance = [];
            }
        },
        addEvent(){
            console.log('addEvent');
            this.selected = {
                InsID: 0,
                TypeInstruction: 1,
                InsTypeCapacitor: 1
            };
            this.selectedCapacitor = {};
            this.itemsCapacitor = [];
            this.selectedAttendance = [];
            this.selectedAttendanceCapacitor = [];

            this.disabledCamera = true;
            this.dialogAddEdit = true;
            this.disabledTotal = false;

            this.filterAttendance = {
                InsID: 0,
                IasDate: this.$fun.getDate()
            }
        },
        editEvent(){
            console.log('editEvent', this.selected);
            this.selectedCapacitor = {};
            this.itemsCapacitor = [];
            this.selectedAttendance = [];
            this.selectedAttendanceCapacitor = [];
            
            this.disabledCamera = false;
            this.dialogAddEdit = true;

            if(this.selected.InsStatus == 3){
                this.disabledTotal = true;
            }
            else{
                this.disabledTotal = false;
            }

            this.filterAttendance = {
                InsID: this.selected?.InsID || 0,
                IasDate: this.selected.InsDate || this.$fun.getDate()
            }
        },
        closeEvent(){
            this.dialogAddEdit = false;
            this.$refs.scrudEventos.refresh();
        },
        returnPersonAttendance(event, item) {
            if(event){
                console.log('event', event);
                item.NtpFullName = event.NtpFullName;
                item.NtpID = event.NtpID;
                item.WkrID = event.WkrID;
                item.PrsDocumentNumber = event.PrsDocumentNumber;
                item.AreID = event.AreID;
                item.AreName = event.AreName;
                item.CtrID = event.CtrID;
                item.JrpID = event.JrpID;
                item.TypeWorker = event.TypeWorker;

                item.IasDocumentNumber = event.PrsDocumentNumber;
            }
        },
        returnPersonAttendanceMasive(event, item) {
            if(event){
                console.log('event', event);
                item.NtpFullName = event.NtpFullName;
                item.NtpID = event.NtpID;
                item.WkrID = event.WkrID;
                item.PrsDocumentNumber = event.PrsDocumentNumber;
                item.AreID = event.AreID;
                item.AreName = event.AreName;
                item.CtrID = event.CtrID;
                item.JrpID = event.JrpID;
                item.TypeWorker = event.TypeWorker;

                item.IasDocumentNumber = event.PrsDocumentNumber;
                item.InsID = this.selected.InsID;
                item.IasDate = this.filterAttendance.IasDate;

                console.log('item', item);

                this.image = null;

                HelperService.getPhotoWorkerBase64(
                    item.PrsDocumentNumber,
                    this.$fun.getUserID()
                ).then((rsp) => {
                    if (rsp.status === 200 && rsp.data) {
                        this.image = 'data:image/jpg;base64,' + rsp.data;
                    } else {
                        console.error("No se pudo cargar la imagen");
                        this.image = null;
                    }
                }).catch((error) => {
                    console.error("Error al obtener la imagen:", error);
                    this.image = null; 
                });

                _sInstructionAttendance.save(item, this.$fun.getUserID()).then(resp => {
                    if(resp.status == 200){
                        this.$fun.alert("Guardado Correctamente", "success");
                        this.PrsDocumentNumber = null;
                        this.$refs.crudAttendance.refresh();
                        this.$refs.document.reset();
                        this.$refs.document.focus();
                    }
                }).catch((error) => {
                    console.error("Error al obtener la imagen:", error);
                    this.PrsDocumentNumber = null;
                    this.$refs.crudAttendance.refresh();
                    this.$refs.document.reset();
                    this.$refs.document.focus();
                });
            }
        },
        returnInstructor(event, item)
        {
            if(!event){
                this.hasWorker = false;
                return;
            }

            console.log('event', event);
            item.NtpFullName = event.NtpFullName;
            item.NtpID = event.NtpID;
            item.WkrID = event.WkrID;
            item.PrsDocumentNumber = event.PrsDocumentNumber;
            item.AreID = event.AreID;
            item.AreName = event.AreName;
            item.CtrID = event.CtrID;
            item.JrpID = event.JrpID;
            item.TypeWorker = event.TypeWorker;

            item.IinDocumentNumber = event.PrsDocumentNumber;
            item.IinNamePerson = event.NtpFullName;
            this.hasWorker = true;
        },
        calcularHoraFin(item) {
            const inicio = item.IInicioTime;
            const duracion = item.IinDurationTime;

            if (!inicio || duracion === null || duracion === '' || isNaN(Number(duracion))) {
                item.IFinTime = '';
                return;
            }

            const [hora, minuto] = inicio.split(':').map(Number);
            const fecha = new Date(0, 0, 0, hora, minuto);

            fecha.setMinutes(fecha.getMinutes() + Number(duracion));

            const horasFinal = fecha.getHours().toString().padStart(2, '0');
            const minutosFinal = fecha.getMinutes().toString().padStart(2, '0');

            item.IFinTime = `${horasFinal}:${minutosFinal}`;
        },
        openCamera() {
            this.getphotoBD();
            this.dialogCamera = true;
        },
        async saveAttendanceInstructor() {
            const selectData = [...this.selectedAttendance];
            for (let i = 0; i < selectData.length; i++) {
                selectData[i].IinID = this.selectedCapacitor.IinID;
                selectData[i].IasID = null;
                await _sInstructionAttendance.save(selectData[i], this.$fun.getUserID()).then(resp => {
                    if(resp.status == 200){
                        console.log(resp);
                    }
                })
            }

            this.$fun.alert("Asistencia Guardada", "success");
            this.$refs.crudAttendance.refresh();
            
            this.paginationListCapacitor(this.selectedCapacitor);
        },
        removeAttendanceCapacitor(item) {
            if(item != null && item.length > 0){
                console.log('item', item);
                const data = item[0];
                data.SecStatus = 0;
                data.UsrCreateID = this.$fun.getUserID();
                data.UsrUpdateID = this.$fun.getUserID();

                this.$fun.alert("¿Desea eliminar la asistencia?", "question").then(resp => {
                    if(resp.value){
                        _sInstructionAttendance.save(data, this.$fun.getUserID()).then(resp => {
                            if(resp.status == 200){
                                this.$fun.alert("Asistencia Eliminada", "success");
                                this.paginationListCapacitor(this.selectedCapacitor);
                            }
                        })
                    }
                })
            }
        },
        async saveEvidence(InsIDCamera) {
            if(InsIDCamera){
                console.log('InsIDCamera', InsIDCamera);
                console.log("itemAnexo1", this.itemAnexo1);
                console.log("itemAnexo2", this.itemAnexo2);

                let cont = 0;
                let fallos = 0;

                if (this.anexosInstruction.itemAnexo1) {
                try {
                    const respImg = await GenUploadFiles.upload(this.anexosInstruction.itemAnexo1, `InsID_${InsIDCamera}_Anexo1`, "routeGestionHumana", true);
                    if(respImg.status == 200){
                    cont++;
                    this.selected.itemAnexo1 = respImg.data.fileName;
                    }
                } catch (error) {
                    fallos ++;
                    this.$fun.alert("Error al subir la foto", "warning");
                    console.error("Error al subir la foto", error);
                }
                }

                if(this.anexosInstruction.itemAnexo2){
                try {
                    const respImg = await GenUploadFiles.upload(this.anexosInstruction.itemAnexo2, `InsID_${InsIDCamera}_Anexo2`, "routeGestionHumana", true);
                    if(respImg.status == 200){
                    cont++;
                    this.selected.itemAnexo2 = respImg.data.fileName;
                    }
                } catch (error) {
                    fallos ++;
                    this.$fun.alert("Error al subir la foto", "warning");
                    console.error("Error al subir la foto", error);
                }
                }

                if(this.anexosInstruction.itemAnexo4){
                try {
                    const respFlyer = await GenUploadFiles.upload(this.anexosInstruction.itemAnexo4, `InsID_${InsIDCamera}_Flyer`, "routeGestionHumana", true);
                    if(respFlyer.status == 200){
                    cont++;
                    this.selected.itemAnexo4 = respFlyer.data.fileName;
                    }
                } catch (error) {
                    fallos ++;
                    this.$fun.alert("Error al subir el flyer", "warning");
                    console.error("Error al subir el flyer", error);
                }
                }

                if(cont > 0 && fallos == 0){
                    this.$fun.alert("Anexos Guardados", "success");
                    console.log("this.selected", this.selected);
                    this.saveEvent(this.selected);
                    this.getphotoBD();
                    this.anexosInstruction.itemAnexo1 = null;
                    this.anexosInstruction.itemAnexo2 = null;
                    this.anexosInstruction.itemAnexo4 = null;
                }
            }
        },
        async uploadPDFEvent() {
            let cont = 0;
            let fallos = 0;

            if (this.anexosInstruction.itemAnexo3) {
                try {
                    const respImg = await GenUploadFiles.upload(this.anexosInstruction.itemAnexo3, `InsID_${this.selected.InsID}_Anexo3`, "routeGestionHumana", true);
                    if(respImg.status == 200){
                    cont++;
                    this.selected.itemAnexo3 = respImg.data.fileName;
                    }
                } catch (error) {
                    fallos ++;
                    this.$fun.alert("Error al subir archivo", "warning");
                    console.error("Error al subir archivo", error);
                }
            }

            if(cont > 0 && fallos == 0){
                this.$fun.alert("Anexos Guardados", "success");
                console.log("this.selected", this.selected);
                this.saveEvent(this.selected);
                this.anexosInstruction.itemAnexo3 = null;
            }
        },
        getphotoBD() {
            console.log("getphotoBD", this.selected);
            if(this.selected.itemAnexo1){
                this.loadingItemAnexo1 = true;
                GenUploadFiles.getFile("routeGestionHumana", `${this.selected.itemAnexo1}`, true)
                .then(base64 => {
                    this.anexosInstruction.itemAnexo1DB = base64;
                    this.loadingItemAnexo1 = false;
                })
                .catch(error =>{
                    console.error("Error al obtener imagen:", error)
                    this.loadingItemAnexo1 = false
                });
            }

            if(this.selected.itemAnexo2){
                this.loadingItemAnexo2 = true;
                GenUploadFiles.getFile("routeGestionHumana", `${this.selected.itemAnexo2}`, true)
                .then(base64 => {
                    this.anexosInstruction.itemAnexo2DB = base64;
                    this.loadingItemAnexo2 = false;
                

            if(this.selected.itemAnexo4){
                this.loadingItemAnexo4 = true;
                GenUploadFiles.getFile("routeGestionHumana", `${this.selected.itemAnexo4}`, true)
                .then(base64 => {
                    this.anexosInstruction.itemAnexo4DB = base64;
                    this.loadingItemAnexo4 = false;
                })
                .catch(error => {
                    console.error("Error al obtener flyer:", error)
                    this.loadingItemAnexo4 = false
                });
            }})
                .catch(error => {
                    console.error("Error al obtener imagen:", error);
                    this.loadingItemAnexo2 = false
                });
            }
        },
        downloadFile(fileName) {
            if(fileName){
                GenUploadFiles.getFile("routeGestionHumana", `${fileName}`)
                .then(resp => {
                    console.log("resp", resp);
                })
                .catch(error => console.error("Error al obtener imagen:", error));
            }
        },
        openRegister() {
            this.selectMasive = {};
            this.image = null;
            this.dialogRegister = true;
        },
        getCenterCost(){
            _sInstruction.getcentercost(this.$fun.getUserID())
            .then((resp) => {
                if (resp.status == 200){
                    this.itemsCenterCost = resp.data;
                }
            })
        },
        iinReturnSubject(value, item) {
            value = value || {};
            item.IsbID = value?.IsbID || 0;
            item.TypeInstruction = value.TypeInstruction;
            item.IinDurationTime = value.IsbDuration;
        },
        colorStatus(item) {
            if (item == 1) {
                return "error";
            } else if (item == 2) {
                return "warning";
            }else if (item == 3) {
                return "success";
            }else{
                return "white";
            }
        }
    },
    computed: {
        centerCostModel: {
            get() {
                const item = this.selected.InsCenterCost;
                if (!item) return [];
                if (typeof item === 'string') {
                try {
                    const parsed = JSON.parse(item);
                    if (Array.isArray(parsed)) return parsed;
                    return item.split(',');
                } catch {
                    return item.split(',');
                }
                }
                return Array.isArray(item) ? item : [];
            },
            set(val) {
                this.selected.InsCenterCost = val.join(',');
            }
        },
        filterCapacitor() {
            return {
                InsID: this.selected.InsID,
            };
        }
    },
    watch: {
        'filterAttendance.IasDate'() {
            this.paginationListCapacitor(this.selectedCapacitor);
        },
        PrsDocumentNumber_AttendanceCapacitor(newVal, oldVal) {
            this.paginationListCapacitor(this.selectedCapacitor);
        },
    },
    created() {
        if (this.$fun.isLevelArea()) {
            this.arePermiss = this.$fun.getSecurity().AreasAllow;  
            this.filter.AreID = this.arePermiss[0].AreID;
            this.filter.AreName = this.arePermiss[0].AreName;
        }

        this.getCenterCost();
    }
}

</script>